// ImportData.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ImportDataComponent from "../importData/ImportData";
import BottomTabBar from "../components/BottomTabBar";

const ImportData = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("customer_id")) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="min-h-[100dvh] bg-gray-50 w-full flex flex-col pb-24 sm:pb-28">
      <div className="flex-1 w-full min-w-0 px-2 sm:px-4 pt-4">
        <ImportDataComponent />
      </div>
      <BottomTabBar />
    </div>
  );
};

export default ImportData;
